


































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Form } from "element-ui";
import {
  addEviDict,
  updateEviDict,
  deleteEviDict,
  getEviDictPageList,
  defaultEviDictData
} from "@/api/evidict";
import { getEviBusinessbehaviorArr } from "@/api/evibusinessbehavior";
import { getEviSubjectArr } from "@/api/evisubject";
import { dictTypeDic, applyTypeDic } from "@/enum";
import { IEviDict } from "@/model/evidict";
import Pagination from "@/components/Pagination/index.vue";

@Component({
  name: "eviDict",
  components: {
    Pagination
  },
  filters: {
    dictTypeFilter: (key: number) => {
      return dictTypeDic.find((o: any) => o.key === key)?.value;
    },
    businessTypeFilter: (key: number) => {
      return applyTypeDic.find((o: any) => o.key === key)?.value;
    }
  }
})
export default class extends Vue {
  private tableKey = 0;
  private eviDictData = defaultEviDictData;
  private list: IEviDict[] = [];
  private dictTypeDic = dictTypeDic;
  private applyTypeDic = applyTypeDic;
  private pidDic = [];
  private pidSearchDic = [];
  private total = 0;
  private listLoading = false;
  private listQuery = {
    pageIndex: 1,
    pageSize: 20,
    search: "",
    businessType: -1,
    pid: ""
  };

  private dialogCreateVisible = false;

  private createRules = {
    type: [
      {
        required: true,
        message: "模板类别必填",
        trigger: "blur"
      }
    ],

    businessType: [
      {
        type: "number",
        min: 0,
        required: true,
        message: "使用类别必填",
        trigger: "change"
      }
    ],

    pid: [{ required: true, message: "归属类别必填", trigger: "change" }],

    key: [{ required: true, message: "标签必填", trigger: "blur" }],

    description: [{ required: true, message: "描述必填", trigger: "blur" }]

    // createTime: [{ required: true, message: "创建时间必填", trigger: "blur" }],

    // creatorId: [{ required: true, message: "创建时间必填", trigger: "blur" }],

    // sort: [{ max: 10, message: "长度不能超过10位" }]

    // updateTime: [{ required: true, message: "更新时间必填", trigger: "blur" }],

    // updateId: [{ required: true, message: "更新人必填", trigger: "blur" }]
  };

  private openCreateDialog() {
    this.initData();
    this.dialogCreateVisible = true;
  }

  private closeCreateDialog() {
    (this.$refs.createForm as Form).resetFields();
    this.pidDic = [];
    this.dialogCreateVisible = false;
  }

  created() {
    this.getList();
  }

  private handleFilter() {
    this.listQuery.pageIndex = 1;
    this.getList();
  }

  private handleUpdate(data: IEviDict) {
    this.dialogCreateVisible = true;
    // this.eviAppData = data;
    this.setData(data);
    this.getPidDic();
  }

  private HandleBusinessTypeChange() {
    this.eviDictData.pid = "";
    this.getPidDic();
  }

  private HandleBusinessTypeSearchChange() {
    this.listQuery.pid = "";
    this.getPidSearchDic();
  }

  private initData() {
    this.eviDictData.id = 0;
    this.eviDictData.type = 2;
    this.eviDictData.businessType = -1;
    this.eviDictData.pid = "";
    this.eviDictData.key = "";
    this.eviDictData.description = "";
    this.eviDictData.createTime = null;
    this.eviDictData.creatorId = "";
    this.eviDictData.sort = 0;
    this.eviDictData.updateTime = null;
    this.eviDictData.updateId = "";
    this.eviDictData.creatorName = "";
    this.eviDictData.updateName = "";
    this.eviDictData.pidName = "";
  }

  private setData(data: IEviDict) {
    this.eviDictData.id = data.id;
    this.eviDictData.type = data.type;
    this.eviDictData.businessType = data.businessType;
    this.eviDictData.pid = data.pid;
    this.eviDictData.key = data.key;
    this.eviDictData.description = data.description;
    this.eviDictData.createTime = data.createTime;
    this.eviDictData.creatorId = data.creatorId;
    this.eviDictData.sort = data.sort;
    this.eviDictData.updateTime = data.updateTime;
    this.eviDictData.updateId = data.updateId;
    this.eviDictData.creatorName = data.creatorName;
    this.eviDictData.updateName = data.updateName;
    this.eviDictData.pidName = data.pidName;
  }

  private async getPidDic() {
    if (this.eviDictData.businessType === 1) {
      const { data } = await getEviSubjectArr();
      this.pidDic = data;
    } else {
      const { data } = await getEviBusinessbehaviorArr();
      this.pidDic = data;
    }
  }

  private async getPidSearchDic() {
    if (this.listQuery.businessType === 1) {
      const { data } = await getEviSubjectArr();
      this.pidSearchDic = data;
    } else {
      const { data } = await getEviBusinessbehaviorArr();
      this.pidSearchDic = data;
    }
  }

  private deleteFunc(id: string) {
    this.$confirm("此操作将永久删除, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        await deleteEviDict(id).then(() => {
          this.getList();

          this.$message({
            type: "success",
            message: "删除成功!"
          });
        });
      });
    // .catch(() => {
    //   this.$message({
    //     type: "info",
    //     message: "已取消删除"
    //   });
    // });
  }

  private async updateFunc() {
    (this.$refs.createForm as Form).validate(async valid => {
      if (valid) {
        console.log(this.eviDictData);
        await updateEviDict(this.eviDictData);

        this.$message({
          message: "修改成功",
          type: "success",
          duration: 2000
        });

        this.initData();
        this.dialogCreateVisible = false;
        this.getList();
      }
    });
  }

  private async createFunc() {
    (this.$refs.createForm as Form).validate(async valid => {
      if (valid) {
        await addEviDict(this.eviDictData).then(() => {
          this.$message({
            message: "创建成功",
            type: "success",
            duration: 2000
          });

          this.initData();
          this.dialogCreateVisible = false;
          this.getList();
        });
      }
    });
  }

  // 获取列表数据
  private async getList() {
    this.listLoading = true;
    const { data } = await getEviDictPageList(this.listQuery);
    this.list = data.list;
    this.total = data.total;
    // Just to simulate the time of the request
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }
}
